<template>
  <div class="gs-app gs-default-funnel-resource">
    <div class="w-full gs-default-funnel-resource__content">
      <v-wait for="resources">
        <div v-if="funnels.length" id="resources-list-view" class="mt-8"></div>
        <div v-else class="mt-8">
          {{ $t('frontend_resources_nofunnels') }}
        </div>
      </v-wait>
    </div>

    <portal to="headerBreadCrumb">
      <div class="flex items-center cursor-pointer -ml-4" @click="sendToFunnels">
        <chevron-left-icon class="h-3 fill-current" />
      </div>
    </portal>
  </div>
</template>

<script>
import Funnel from '@/models/Funnel';
import ChevronLeftIcon from '@/assets/images/icons/ChevronLeftIcon.svg';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('funnel_promo_tools') };
  },
  components: {
    ChevronLeftIcon
  },
  data() {
    return {
      funnels: [],
    };
  },
  async created() {
    this.$wait.start('resources');
    await this.loadFunnels();
    this.$wait.end('resources');
  },
  methods: {
    async loadFunnels() {
      this.funnels = await Funnel.$get();
      if (this.funnels.length) {
        this.$router.push({
          name: 'funnel_resources',
          params: {
            id: this.funnels[0].id
          }
        });
      }
    },
    sendToFunnels() {
      this.$router.push({ name: 'funnels' });
    }
  }
};
</script>

<style scoped>
.gs-default-funnel-resource {
  min-height: 100%;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gs-default-funnel-resource__content {
  min-width: 0;
}
</style>

<style lang="scss">
.dropdown-toggle {
  background-image: none !important;
  border: 1px solid dodgerblue !important;
  border-radius: 30px;
}

.dropdown-toggle:hover {
  background: transparent;
}

.dropdown-button-container {
  display: flex;
  align-items: center;

  .btnx {
    border-radius: 5px 0px 0px 5px;
  }

  .btn-drop {
    border-radius: 0px 5px 5px 0px;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
  }
}
</style>
